
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/new",
      function () {
        return require("private-next-pages/partners/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/new"])
      });
    }
  